// GA event metadata for A/B testing exposure and conversion events.
// Enum keys must match GA_LABEL_ENUMS in GAEvents.ts; the `label` field is
// what lands in payload.event_name on the Lambda Pixel emit.
// Per-event A/B attribution (experiment_id, variant_id, source) rides on
// the `custom_object` 5th arg of triggerGAEvent.
export const ab_testing_events = {
  ab_experiment_exposure: {
    category: "A/B Testing",
    action: "User exposed to an experiment variant",
    label: "ab-experiment-exposure",
  },
  ab_experiment_conversion: {
    category: "A/B Testing",
    action: "User completed a conversion event in an experiment",
    label: "ab-experiment-conversion",
  },
};
